import React from "react";
import styled from "styled-components";

export default styled.select`
    width: 210px;
    display: inline-block;
    box-sizing: border-box;
    height: auto;
    font-size: 16px;
    padding-right: 9px;
    border: none;
    float: left;
    color: #717198;
    
    
        display: ${(props) => (props.hidden ? "none" : "block")};
`; 